import * as Constants from "../../constants/urls";
import React, { Fragment, useState } from "react";
import Header from "../Header/Header";
import { Drawer } from "@mui/material";
import RightMenu from "../Header/RightMenu";
import Alerts from "../Alerts";
import axios from "axios";
import { useCookies } from "react-cookie";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

function ReplaceUrl() {
    const [alert, setAlert] = useState(false);
    const [alertType, setAlertType] = useState("alert-success");
    const [alertMassage, setAlertMassage] = useState("");
    const [alert2, setAlert2] = useState(false);
    const [alertType2, setAlertType2] = useState("alert-success");
    const [alertMassage2, setAlertMassage2] = useState("");
    const [state, setState] = useState({ right: false });
    const [searchString, setSearchString] = useState("");
    const [replaceString, setReplaceString] = useState("");
    const [cookies, setCookie, removeCookie] = useCookies();
    const [loading , setLoading]=useState(false);
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    function alert_on() {
        setAlert(true);
    }

    function alert_off() {
        setAlert(false);
    }

    function alert_on2() {
        setAlert2(true);
    }

    function alert_off2() {
        setAlert2(false);
    }

    const countReplaces = async () => {
        setLoading(true);
        if (searchString == "" && replaceString == "") return;
        const url = Constants.apiUrl + `/api/replace_url_count`;
        await axios
            .post(
                `${url}`,
                {
                    searchString,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((response) => {
     
                const confirm = window.confirm(
  `آیا از تغییر ${response.data.catCount} دسته، ${response.data.productCount} محصول، ${response.data.groupCount} گروه، ${response.data.courseCount} کلاس، ${response.data.classCount} جلسه کلاس، ${response.data.bannerCount} بنر و ${response.data.postCount} بلاگ اطمینان دارید؟`
);
                if (confirm) {
 
                    submitForm();
 
                }
                else
                        setLoading(false);

            })
            .catch((error) => {
                alert_on();
                setAlertType("alert-danger");
                setAlertMassage("خطایی رخ داده است !");
                setLoading(false)
                console.log(error);
            });
    };

    const submitForm = async () => { 
        setLoading(true);
        const url = Constants.apiUrl + `/api/replace_url`;
        await axios
            .post(
                `${url}`,
                {
                    searchString,
                    replaceString,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((response) => {
                    setLoading(false);
                console.log(response);
                if (response.data.catCount > 0) {
                    if (response.data.catStatus === 0) {
                        setAlertMassage(
                            "تغییر آدرس روی دسته ها با موفقیت اعمال شد",
                        );
                        alert_on();
                        setAlertType("alert-success");
                    
                    } else {
                        setAlertMassage(
                            `تغییر آدرس روی ${response.data.catStatus} دسته ثبت نشد`,
                        );
                        alert_on();
                        setAlertType("alert-danger"); 

                    }
                }
                if (response.data.productCount > 0) {
                    if (response.data.productStatus === 0) {
                        setAlertMassage2(
                            "تغییر آدرس روی محصولات با موفقیت اعمال شد",
                        );
                        alert_on2();
                        setAlertType2("alert-success");
                    } else {
                        setAlertMassage2(
                            `تغییر آدرس روی ${response.data.productStatus} محصول ثبت نشد`,
                        );
                        alert_on2();
                        setAlertType2("alert-danger");
                    }
                }
                // if (response.data.status == "failed") {
                //     // window.location.href = "https://honari.com";

                //     setAlertMassage(response.data.message);
                //     alert_on();
                //     setAlertType("alert-danger");
                // } else {
                //     setAlertMassage(response.data.message);
                //     alert_on();
                //     setAlertType("alert-success");
                // }
            })
            .catch((error) => {
                                        setLoading(false);

                alert_on();
                setAlertType("alert-danger");
                setAlertMassage("خطایی رخ داده است !");
                console.log(error);
            });
    };
    return (
        <Fragment>
            <Breadcrumb title={"تغییر آدرس"} />

            {alert == true && (
                <Alerts
                    type={alertType}
                    text={alertMassage}
                    close={alert_off}
                />
            )}
            {alert2 == true && (
                <Alerts
                    type={alertType2}
                    text={alertMassage2}
                    close={alert_off2}
                />
            )}
            <div
                className="container my-4"
                style={{
                    padding: "25px",
                    borderRadius: "15px",
                    border: "1px solid rgb(219, 219, 219)",
                }}
            >
                <div className="row">
                    <div className="col-6 text-center">
                        <span className="d-inline-block"> جایگزاری آدرس</span>
                        <input
                            tabIndex={2}
                            type="text"
                            className="form-control d-inline-block"
                            onChange={(e) => setReplaceString(e.target.value)}
                            value={replaceString}
                        />
                    </div>
                    <div className="col-6 text-center">
                        <span className="d-inline-block"> جستجوی آدرس</span>
                        <input
                            tabIndex={1}
                            type="text"
                            className="form-control d-inline-block"
                            onChange={(e) => setSearchString(e.target.value)}
                            value={searchString}
                        />
                    </div>
                    <div className="col mt-4">
                        <button
                            tabIndex={3}
                            className="btn btn-block btn-success"
                            onClick={countReplaces}
                            disabled={loading}
                        >
                        {
                            loading?"صبر کنید":"اعمال"
                        }
                            {" "}
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default ReplaceUrl;
